var exports = {
  "A": "xae11d333--98a9da--item",
  "C": "xae11d333--98a9da--bold",
};

module.exports = exports;
